<div  style="overflow: hidden;" >
    <br/>
    <div fxFlexlayout="row" style="height: 10ch"></div>
    <!-- mobile -->
    <div class="font-size" fxLayout="column" *ngIf="sidenavService.mobileQuery?.matches">
      <div class="mat-headline-4 auto_margin">
        <span i18n><b>{{'guest.You look'|translate}}</b>&nbsp;</span>
        <span [@changeDivSize]="[textBlink]"><b>{{typewriter_display}}</b></span>
        <span class="blinkerMobile blinker" [@blinker]="blinker"></span>
      </div>
      <div class="mat-headline-4 auto_margin" i18n>{{'guest.when'|translate}}</div>
      <div class="mat-headline-4 auto_margin" style="text-align: center;"><b>{{ changing_qoute |translate }}</b></div>
    </div>

    <div fxLayout="row">

      <div fxLayout="column" fxFlex="5"></div>
      <div fxLayout="column" fxFlex="50" *ngIf="!sidenavService.mobileQuery?.matches">
        <div fxFlexlayout="row" style="height: 2ch"></div>
        <div fxFlexlayout="row" class="mat-headline-3 auto_margin">
          {{ 'login-dialog.main_heading'| translate }}
        </div>
        <div fxFlexlayout="row">
          <div fxLayout="column" fxLayout="column" fxFlex="25"></div>
          <div fxLayout="column" fxLayout="column" fxFlex="50">
            <img src="https://storage.googleapis.com/jivrus-web-images/avatar/man-working-laptop.gif">
          </div>
          <div fxLayout="column" fxLayout="column" fxFlex="25"></div>
        </div>

        <div fxFlexlayout="row" style="height: 5ch"></div>

        <div fxFlexlayout="row" style="height: 10ch"></div>

      </div>


      <div fxLayout="column" class="right_background"  fxFlex="40" fxFlex.lt-sm="120">
        <div fxFlexlayout="row" style="height: 5ch" fxHide.lt-sm></div>
        <app-login-dialog [inputParams]="loginParams" [selectedWorkspace]="selectedWorkspaceId" ></app-login-dialog>
      </div>
      <div fxLayout="column" fxFlex="5"></div>
    </div>

    <br/>
    <br/>
  </div>
